<template>
  <span class="go-back">
    <button @click="$router.back()">Go Back</button>
  </span>
</template>
